import React, {memo} from 'react';
import PropTypes from 'prop-types';

const ViewMoreLink = ({link, text}) => (
  <a className="d-flex align-items-center" href={link}>
    {text}&nbsp;
    <i className="icon icon-right-arrow" aria-hidden="true" />
  </a>
);

ViewMoreLink.propTypes = {
  link: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

export default memo(ViewMoreLink);
